import { defineStore } from 'pinia'

export const useMapStore = defineStore('map', {
  state: () => ({
    isLoading: false,
    error: null,
    mapData: null,
    visibleLayers: ['accessibility']
  }),
  
  actions: {
    setLoading(loading) {
      this.isLoading = loading
    },
    
    setError(error) {
      this.error = error
    },
    
    setMapData(data) {
      this.mapData = data
    },
    
    toggleLayer(layerName) {
      const index = this.visibleLayers.indexOf(layerName)
      if (index > -1) {
        this.visibleLayers.splice(index, 1)
      } else {
        this.visibleLayers.push(layerName)
      }
    },
    
    isLayerVisible(layerName) {
      return this.visibleLayers.includes(layerName)
    }
  }
}) 